// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=8080&pathname=%2Fws&logging=info&overlay=false&reconnect=10&hot=true&live-reload=true");
__webpack_require__("./node_modules/webpack/hot/dev-server.js");
__webpack_require__("./node_modules/react-app-polyfill/ie9.js");
__webpack_require__("./node_modules/react-app-polyfill/stable.js");
var __webpack_exports__ = __webpack_require__("./src/main.jsx");
